/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type UpdateOrganizationMutationVariables = Types.Exact<{
  organization_id: Types.Scalars['uuid']['input'];
  updatePayload: Types.Organizations_Set_Input;
}>;

export type UpdateOrganizationMutation = {
  __typename?: 'mutation_root';
  update_organizations_by_pk?: { __typename?: 'organizations'; id: string } | null;
};

export const UpdateOrganizationDocument = `
    mutation UpdateOrganization($organization_id: uuid!, $updatePayload: organizations_set_input!) {
  update_organizations_by_pk(
    pk_columns: {id: $organization_id}
    _set: $updatePayload
  ) {
    id
  }
}
    ` as string &
  TypedDocumentNode<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    UpdateOrganization: build.mutation<
      UpdateOrganizationMutation,
      UpdateOrganizationMutationVariables
    >({
      query: (variables) => ({ document: UpdateOrganizationDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useUpdateOrganizationMutation } = injectedRtkApi;
